module.exports = __webpack_public_path__ + "static/media/icon_allowance_admin.73f19b71.svg";